import { useHistory, Route, Link } from "react-router-dom";
import { Fragment, useEffect, useState, useMemo } from "react";
//-----------------------------------------------------------------------------------------
import TransitionWidthHeight from "src/components/common/TransitionWidthHeight";
import Resize from "src/components/common/resize";
import UserInfo from "src/components/common/userInfo";
import magnifierImg from "src/img/magnifier.png";
import star from "src/img/star.png";
import unstar from "src/img/unstar.png";
import Footer from "src/components/common/frame/footer";
import { useMyStore } from "src/components/main/mainStore";
import {
    MyFormData, myAxios, reportWriterEmails, projectCategoryColorCode, 
    pipelineOptions, subPipelineOptions, regionOptions, 
    scroll, addDate, usaExpireColorCode, arrayReducer, 
    restDayProjectHashKey, boolAndReducer, objAscSort, onlyUnique,
    appTitle, safeParseJson
} from "src/components/common/functions";
import Export from "./projectExport";
import ProjectForm from "./projectForm";
import FilterForm from "./projectFilterForm";
import ProjectDetail from "./projectDetail";
//-----------------------------------------------------------------------------------------
export default function Projects({tabTitle, tabPath}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const dataFrame = useMemo(() => [
        {
            title: "Project Manager",
            key: "projectManager",
            type: "select", 
            filterOptions: [] // ?
        },
        {
            title: "Pipeline",
            key: "pipeline",
            type: "select", 
            filterOptions: Object.keys(pipelineOptions).map(v => ({label: v, value: v}))
        },
        {
            title: "Sub Pipeline",
            key: "subPipeline",
            type: "select", 
            filterOptions: Object.values(subPipelineOptions).reduce(arrayReducer, []).filter(onlyUnique).map(v => ({label: v, value: v}))
        },
        {
            title: "Stage",
            key: "stage",
            type: "select", 
            filterOptions: Object.values(pipelineOptions).reduce(arrayReducer, []).filter(onlyUnique).map(v => ({label: v, value: v}))
        },
        {
            title: "Prevailing",
            key: "prevailing",
            type: "select", 
            filterOptions: ["No", "Yes"].map(v => ({label: v, value: v}))
        },
        {
            title: "CPR",
            key: "cpr",
            type: "select", 
            filterOptions: ["No", "Yes"].map(v => ({label: v, value: v}))
        },
        {
            title: "Location",
            key: "location",
            type: "text"
        },
        {
            title: "Opportunity",
            key: "opportunityName",
            type: "text",
        },
        {
            title: "Requestor",
            key: "requestor",
            type: "text"
        },
        {
            title: "Client PO Number",
            key: "clientPONumber",
            type: "text"
        },
        {
            title: "Region",
            key: "region",
            type: "select",
            filterOptions: regionOptions.map(v => ({label: v, value: v}))
        },
        {
            title: "Description",
            key: "projectDescription",
            type: "text"
        },
        {
            title: "Notes",
            key: "projectNotes",
            type: "text"
        },
        {
            title: "Accurate Time",
            key: "accurateTime",
            type: "select", 
            filterOptions: ["No", "Yes"].map(v => ({label: v, value: v}))
        },
        {
            title: "Client Signature Required",
            key: "clientSignatureRequired",
            type: "select", 
            filterOptions: ["No", "Yes"].map(v => ({label: v, value: v}))
        },
        {
            title: "Send To Client",
            key: "sendToClient",
            type: "select", 
            filterOptions: ["No", "Yes"].map(v => ({label: v, value: v}))
        },
        {
            title: "Creator",
            key: "creator",
            type: "select",
            filterOptions: []
        },
        {
            type: "date",
            title: "Date Created",
            key: "projectCreationDate"
        },
        {
            title: "Updator",
            key: "updater",
            type: "select",
            filterOptions: []
        },
        {
            title: "Date Updated",
            key: "projectDateUpdated",
            type: "date"
        },
        {
            title: "Description",
            key: "projectDescription",
            type: "textarea",
            position: "detail",
            editable: true
        },
    ], 
    []);
    const defaultFilter = useMemo(() => 
    Object.fromEntries(
        dataFrame.map(item => 
            !["date", "number"].includes(item.type)?
            [[item.filterKey || item.key, item.defaultValue || ""]]:
            [[item.key + "Min", ""], [item.key + "Max", ""]]
        ).reduce((a,b) => arrayReducer(a, b), [])
    ), 
    [dataFrame]);
    // fav
    const [myFav, setMyFav] = useState(() => {
        try {
            const parsedFav = user.fav ? JSON.parse(user.fav) : {};
            return parsedFav.projects ? parsedFav : { projects: [] };
        } catch (error) {
            console.error("Failed to parse user.fav:", error);
            return { projects: [] }; // Fallback to an empty projects array
        }
    });
    const [showOnlyFavs, setShowOnlyFavs] = useState(false);
    //archive
    const [showArchive, setShowArchive] = useState(false);
    // data
    const [PMList, setPMList] = useState([]);
    const [reportWriterList, setReportWriterList] = useState([]);
    const [oppoList, setOppoList] = useState([]);
    const [contactList, setContactList] = useState([]);
    const [orgList, setOrgList] = useState([]);
    const [userList, setUserList] = useState([]);
    // main data
    const [projects, setProjects] = useState([]);
    // filter
    const [curFilter, setFilter] = useState(defaultFilter);
    // search bar
    const [filterWords, setFilterWords] = useState("");
    // loading
    const [showLoading, setShowLoading] = useState(false);
    // pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    // ** render
    const [projectRenderSwitch, setProjectRenderSwitch] = useState(true);
    //-------------------------------------------------------------------------------------------
    const history = useHistory();
    const URLprojectHashKey = history.location.pathname.split("/")[2];
    //-------------------------------------------------------------------------------------------
    const childRow = e => {
        if(e.currentTarget.children[2 /* userInfo */].contains(e.target)) return;
        if(e.currentTarget.children[1 /* project name */].children[0 /* my fav name */].contains(e.target)) return;
        if(e.currentTarget.children[1 /* project name */].children[3 /* organization name */].contains(e.target)) return;
        if(e.currentTarget.children[4 /* stage */].children[1 /* next stage */]?.contains(e.target)) return;
        const myModal = document.getElementsByClassName("myModal")[0];
        if(myModal && myModal.contains(e.target)) return;
        if(URLprojectHashKey !== e.currentTarget.id){
            history.push(`${tabPath}/${e.currentTarget.id}`);
            scroll(e.currentTarget.id);
            // setCurrentProject(currentPageProjects.filter(p => e.currentTarget.id === p.projectHashKey)[0]);
        }else{
            history.push(tabPath);
            scroll(null);
        }
    }
    //--------------------------------------------------------------------------------------------
    const oppoHK = history.location.pathname.split("/")[3] === "Edit"?
    undefined:history.location.pathname.split("/")[3];
    const indexOfLastProject = currentPage * itemsPerPage;
    const indexOfFirstProject = indexOfLastProject - itemsPerPage;
    const filteredProjects = projects
    .map(project => ({
        ...project,
        usaTicketExpirationDate: project.usaTicketDate?addDate(project.usaTicketDate, 28):""
    }))
    .filter(project => (
        (showOnlyFavs?myFav.projects.includes(project.projectHashKey):true) &&
        // (showArchive?(project.stage === "Received Payment" || project.stage === "Archived"):
        // (project.stage !== "Received Payment" && project.stage !== "Archived")
        (showArchive?(project.stage === "Archived"):
        (project.stage !== "Archived")
        ) &&
        !dataFrame.find(item => !(
            !["date", "number"].includes(item.type)?
            (
                curFilter[item.filterKey || item.key] !== undefined && project[item.filterKey || item.key] !== undefined && curFilter[item.filterKey || item.key] !== defaultFilter[item.filterKey || item.key]?
                project[item.filterKey || item.key]?.toLowerCase().indexOf(curFilter[item.filterKey || item.key].toLowerCase()) > -1:true
            )
            :
            (
                item.type === "date"?
                (
                (curFilter[item.key + "Min"]?project[item.key] >= curFilter[item.key + "Min"]:true)
                && (curFilter[item.key + "Max"]?project[item.key] <= curFilter[item.key + "Max"]:true)
                ):
                (
                (curFilter[item.key + "Min"]?parseFloat(project[item.key]) >= parseFloat(curFilter[item.key + "Min"]):true)
                && (curFilter[item.key + "Max"]?parseFloat(project[item.key]) <= parseFloat(curFilter[item.key + "Max"]):true)
                )
            )
        )) && 
        (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(project)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    ));
    const currentPageProjects = filteredProjects.slice(indexOfFirstProject, indexOfLastProject);
    const projectPageNumbers = Array.from({length: Math.ceil(filteredProjects.length / itemsPerPage)}, (_, i) => (i + 1));
    //-----------------------------------------------------------------------------------------
    const handleSearch = async () => {
        const formData = new MyFormData();
        formData.append("btl", filterWords);
        const filter = [];
        Object.entries(curFilter).forEach(([key, value]) => {
            if(value !== defaultFilter[key]){
                filter.push([key, value]);
            }
        });
        formData.append("filter", JSON.stringify(filter));
        //------------------------------
        setShowLoading(true);
        const res = await myAxios("projects/readProjects.php", formData);
        setShowLoading(false);
        if(!res) return;
        //------------------------------
        const mainData = res.data.map(project => ({...project, projectFiles: safeParseJson(project.projectFiles)}))
        .sort((a, b) => objAscSort(a, b, "projectCreationDate"));
        setProjects(mainData);
        setCurrentPage(1);
    }
    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();
        const getData = async () => {
            //-------------------------
            const formData = new MyFormData();
            //-------------------------
            if(!userList.length){
                //------------------------------
                setShowLoading(true);
                const resUser =  await myAxios("common/readUserNames.php",  formData, undefined, controller.signal);
                if(!isMounted) return;
                setShowLoading(false);
                if(!resUser) return;
                //------------------------------
                const usersList = resUser.data;
                setUserList(usersList);
                setPMList(usersList.filter(user => user.projects === "yes"));
                setReportWriterList(usersList.filter(user => reportWriterEmails.includes(user.email)));
            }
            //-------------------------
            if(!oppoList.length){
                //------------------------------
                setShowLoading(true);
                const resOppos = await myAxios("common/readOppoNames.php", undefined, undefined, controller.signal);
                if(!isMounted) return;
                setShowLoading(false);
                if(!resOppos) return;
                //------------------------------
                setOppoList(resOppos.data);
            }
            //-------------------------
            if(!contactList.length){
                //------------------------------
                setShowLoading(true);
                const resContacts = await myAxios("common/readContact.php", undefined, undefined, controller.signal);
                if(!isMounted) return;
                setShowLoading(false);
                if(!resContacts) return;
                //------------------------------
                setContactList(resContacts.data);
                //-----------------------
                const contactOrgHashKeys = resContacts.data.map(c => c.organizationHashKey);
                const allContactOrgs = resContacts.data.map(c => ({name:c.organizationName, hashKey: c.organizationHashKey}));
                const contactOrgs = allContactOrgs.filter((c, index) => contactOrgHashKeys.indexOf(c.hashKey) === index);
                setOrgList(contactOrgs);
            }
            //---------------------------------------------------------
            let check = "";
            if(URLprojectHashKey){
                formData.append("projectHashKey", URLprojectHashKey);
                //------------------------------
                setShowLoading(true);
                const resCheck = await myAxios("projects/readProject.php", formData, undefined, controller.signal);
                if(!isMounted) return;
                setShowLoading(false);
                if(!resCheck) return;
                //------------------------------
                check = resCheck.data;
            }
            //-------------------------
            setShowLoading(false);
            if(!check){
                switch(URLprojectHashKey){
                    case "Add":
                        return; 
                    case undefined:
                        return
                    default:
                }
                history.replace(tabPath);
                return;
            }else{
                const checkData = check.map(project => ({
                    ...project, 
                    projectFiles: safeParseJson(project.projectFiles)
                }));
                setProjects(checkData);
            }
            setCurrentPage(1);
            scroll(URLprojectHashKey);
        }
        getData();
        return () => {
            isMounted = false;
            controller.abort();
            setShowLoader(false);
        }                              
    },[history, projectRenderSwitch]);
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //-----------------------------------------------------------------------------------------
    return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    {tabTitle}
                </span>
                <span>
                    <input
                        id = "searchBar"
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                        onKeyDown = {e => {
                            if(e.key === "Enter"){
                                handleSearch();      
                            }
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                <span className = "text-info pointer" onClick = {handleSearch}>Search</span>
                <span
                    className = "pointer p-1 rounded"
                    style = {{
                        backgroundColor: showOnlyFavs?
                        "rgb(0,123,255)"
                        :undefined
                    }}
                    onClick = {() => {
                        setShowOnlyFavs(s => !s);
                        setCurrentPage(1);
                    }}
                >Stars</span>
                <span
                    className = "pointer p-1 rounded"
                    style = {{
                        backgroundColor: showArchive?
                        "rgb(0,123,255)"
                        :undefined
                    }}
                    onClick = {() => {
                        setShowArchive(s => !s);
                        setCurrentPage(1);
                    }}
                >Archive</span>
                <FilterForm
                    curFilter = {curFilter}
                    setFilter = {setFilter}
                    projects = {projects}
                    setProjects = {setProjects}
                    setCurrentPage = {setCurrentPage}
                    defaultFilter = {defaultFilter}
                    dataFrame = {dataFrame}
                    filterWords = {filterWords}
                />
                <Export
                    projects = {projects}
                />
                {user.projects !== "readOnly"?
                <>
                <span className = "pointer" onClick = {() => history.push(`${tabPath}/Add`)}>Add</span>
                {URLprojectHashKey === "Add"?
                <ProjectForm
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setProjects = {setProjects}
                    keyword = "Add" 
                    projectCloseIt = {() => {
                        if(oppoHK !== undefined){
                            history.goBack();
                        }else{
                            history.replace(tabPath);
                        }
                    }} //
                    history = {history}
                    projects = {projects}
                    PMList = {PMList}
                    reportWriterList = {reportWriterList}
                    contactList = {contactList}
                    orgList = {orgList}
                    oppoList = {oppoList.filter(e =>
                        {
                            return oppoList.indexOf(e.opportunityHashKey) < 0
                        }, projects.map(p => p.opportunityHashKey))
                    } //
                    oppoHK = {oppoHK}
                    setProjectRenderSwitch = {setProjectRenderSwitch}
                />
                :<></>}
                </>
                :<></>}
            </div>
            <div className = {`cssContent` + (!showLoading && filteredProjects.length?" pb10":"")}>
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !projects.length?
                <div className = "cssLoading">
                    <div>Please search <span className = "text-info">Project Number</span> or <span className = "text-info">Client Name</span> or <span className = "text-info">Client Project Number</span> on the search bar and hit "Search" button right next to it.</div>
                    <div>(Empty search bar will load <span className = "text-danger">all</span> projects)</div>
                </div>:
                !currentPageProjects.length?<div className = "cssLoading">No Project Yet</div>:
                <div className = "table-responsive">
                <table className = "table">
                    <thead className = "noTableTopBorder">
                        <tr>
                            <th></th>
                            <th>Project Name</th>
                            <th>Project Manager</th>
                            <th>Pipeline</th>
                            <th>Stage</th>
                            <th>Prevailing Job</th>
                            <th>Certified PayRoll</th>
                            <th>DIR Number</th>
                            <th>USA Expire</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentPageProjects.map((project, projectIndex) => (
                        <Fragment key = {projectIndex}>
                        <tr 
                            className = "pointer" 
                            id = {project.projectHashKey} 
                            onClick = {childRow}
                        >
                            <td
                                className = {
                                    URLprojectHashKey === project.projectHashKey?
                                    "showMinus":"showPlus"
                            }>
                            </td>
                            <td>
                                {myFav.projects?.includes(
                                    project.projectHashKey
                                )?
                                <img
                                    src = {star}
                                    alt = ""
                                    className = "mx-2"
                                    onClick = {async() => {
                                        const formData = new MyFormData();
                                        formData.append(
                                            "projectHashKey", 
                                            project.projectHashKey
                                        );
                                        //------------------------------
                                        setShowLoader(true);
                                        const res = await myAxios("/projects/deleteFav.php", formData);
                                        setShowLoader(false);
                                        if(!res) return;
                                        //------------------------------
                                        setMyFav(res.data);
                                    }}
                                />
                                :
                                <img
                                    src = {unstar}
                                    alt = ""
                                    className = "mx-2"
                                    onClick = {async() => {
                                        const formData = new MyFormData();
                                        formData.append(
                                            "projectHashKey", 
                                            project.projectHashKey
                                        );
                                        //------------------------------
                                        setShowLoader(true);
                                        const res = await myAxios("/projects/addFav.php", formData);
                                        setShowLoader(false);
                                        if(!res) return;
                                        //------------------------------
                                        setMyFav(res.data);
                                    }}
                                />
                                }
                                <span>
                                    {project.projectNumber}
                                </span>
                                <span>
                                    &nbsp;-&nbsp;
                                </span>
                                <Link
                                    to = {`/Organizations/${project.clientName}`}
                                >
                                    {project.organizationName}
                                </Link>
                                <span>
                                    &nbsp;-&nbsp;
                                </span>
                                <span>
                                    {project.clientProjectNumber}
                                </span>
                            </td>
                            <td>
                                {project.projectHashKey === 
                                restDayProjectHashKey?
                                <></>:
                                <UserInfo
                                    name = {project.projectManager}
                                    email = {project.projectManagerEmail}
                                />}
                            </td>
                            <td
                                className = "text-white font-weight-bold"
                                style = {{
                                    backgroundColor: 
                                    project.projectHashKey === restDayProjectHashKey?"":
                                    `rgb(${projectCategoryColorCode[project.pipeline]?.rgb.join(",")})`
                                }}
                            >
                                {project.projectHashKey === restDayProjectHashKey?"":
                                (project.subPipeline?`${project.pipeline} - ${project.subPipeline}`:project.pipeline)
                                }
                            </td>
                            <td className = {project.stage === "Report Deliverable"?"cssStageReport":project.stage === "Invoice"?"cssStageInvoice":""}>
                                <span>
                                    {project.projectHashKey === restDayProjectHashKey?"":project.stage}
                                </span>
                                {project.projectHashKey !== restDayProjectHashKey && pipelineOptions[project.pipeline]?.indexOf(project.stage) !== 
                                pipelineOptions[project.pipeline]?.length - 1?
                                <div>
                                    <span
                                        className = "btn btn-primary"
                                        onClick = {async() => {
                                            if(!window.confirm("Are you sure to set this project to the next stage?")) return;
                                            const options = pipelineOptions[project.pipeline];
                                            const index = options.indexOf(project.stage);
                                            const formData = new MyFormData();
                                            formData.append("projectHashKey", project.projectHashKey);
                                            formData.append("stage", options[index + 1]);
                                            //------------------------------
                                            setShowLoader(true);
                                            const res = await myAxios("projects/nextStage.php", formData);
                                            setShowLoader(false);
                                            if(!res) return;
                                            //------------------------------
                                            setProjectRenderSwitch(s => !s);
                                        }}
                                    >
                                        →
                                    </span>
                                </div>
                                :<></>}
                            </td>
                            <td>
                                {project.projectHashKey === restDayProjectHashKey?"":project.prevailing}
                            </td>
                            <td>
                                {project.projectHashKey === restDayProjectHashKey?"":project.cpr}
                            </td>
                            <td>
                                {project.projectHashKey === restDayProjectHashKey?"":project.dirNumber}
                            </td>
                            <td
                                className = "text-white"
                                style = {{
                                    background: 
                                    usaExpireColorCode(
                                        project.usaTicketExpirationDate
                                    )
                                }}
                            >
                                {project.projectHashKey === restDayProjectHashKey?"":project.usaTicketExpirationDate}
                            </td>
                        </tr>
                        <tr>
                            <td
                                className = "noborder"
                                colSpan = {100}
                            >
                                <TransitionWidthHeight
                                    classNames = "cssTDTransition"
                                    In = {URLprojectHashKey === project.projectHashKey}
                                >
                                    <ProjectDetail
                                        userList = {userList}
                                        setProjects = {setProjects}
                                        projects = {projects}
                                        project = {project}
                                        setProjectRenderSwitch = {setProjectRenderSwitch}
                                        tabPath = {tabPath}
                                        updatePopUp = {() => history.replace(`${tabPath}/${URLprojectHashKey}/Edit`)}
                                        generateReport = {async () => {
                                            if(!window.confirm("are you sure to generate report file?n/(this is automated process only for potholing)")) return;
                                            const formData = new MyFormData();
                                            formData.append("projectHashKey", project.projectHashKey);
                                            formData.append("project", JSON.stringify(project));
                                            formData.append("form", "potholingReport");
                                            //------------------------------
                                            setShowLoader(true);
                                            const res = await myAxios("projects/generateReport.php", formData);
                                            setShowLoader(false);
                                            if(!res) return;
                                            //------------------------------
                                            setProjectRenderSwitch(s=>!s);
                                        }}
                                        history = {history}
                                    />
                                    {user.projects !== "readOnly"?
                                    <Route
                                        exact
                                        path = {`${tabPath}/${URLprojectHashKey}/Edit`}
                                        children = {
                                            <ProjectForm
                                                setProjects = {setProjects}
                                                keyword = "Edit"
                                                projectCloseIt = {() => history.replace(tabPath)}
                                                history = {history}
                                                projects = {projects}
                                                PMList = {PMList}
                                                reportWriterList = {reportWriterList}
                                                contactList = {contactList}
                                                orgList = {orgList}
                                                oppoList = {
                                                    oppoList.filter(e => {
                                                        return oppoList.indexOf(e.opportunityHashKey) < 0 || 
                                                        (project.opportunityHashKey?
                                                        oppoList.indexOf(project.opportunityHashKey) >= 0
                                                        :
                                                        false)
                                                    }, projects.map(p => p.opportunityHashKey))
                                                }
                                                oppoHK = {oppoHK}
                                                setProjectRenderSwitch = {setProjectRenderSwitch}
                                                {...project}
                                            />
                                        }
                                    />
                                    :<></>}
                                </TransitionWidthHeight>
                            </td>
                        </tr>
                        </Fragment>
                        ))}
                    </tbody>
                </table>
                </div>}
                {!showLoading && filteredProjects.length?
                <Footer
                    length = {filteredProjects.length}
                    pageNumbers = {projectPageNumbers}

                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}
                />
                :null}
            </div>
        </div>
    )
}